// test1261
(1261 && 0);
